(function() {
    function SurveyService(http) {
        function validateCondition(condition, target) {
			var valid = condition.rule.indexOf(target.value) > -1;

			return condition.reverse ? !valid : valid;
		}
        
        function validateConditions(conditions, answers) {
			var valid = true;
			
			for (var i=0;i < conditions.length;i++) {
				var condition = conditions[i],
					target = answers['q-'+condition.questionId];
				
				if (!target || !validateCondition(condition, target)) {
					valid = false;
					break;
				}
			}

			return valid;
		}

        function createPages(elements) {
            var pages = [
                []
            ];
            
            angular.forEach(elements, function(element, key) {
                if (element.type === 'pagechange' 
                    && (key !== 0 || key !== elements.length - 1))  {
                    pages.push([]);
                } else {
                    pages[pages.length - 1].push(element);
                }
            });
            
            return pages;
        }

        function removeHiddenAnswers(elements, remove, answers) { // remove answers from hidden questions
            angular.forEach(elements, function(element) {
                if (remove && !!element)
                    if (element.type === 'contactDetails')
                        delete answers['contactDetails']
                    else
                        delete answers['q-'+element.questionId];
                
                if (typeof element.elements !== 'undefined')
                    removeHiddenAnswers(element.elements, !validateConditions(element.conditions, answers), answers);
            });
        }

        function validateEmail(email) {
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                    
            return re.test(email);
        }

        function validate(page, answers) {
            var valid = true;
            
            angular.forEach(page, function(element, key) {
                switch (element.type) {
                    case 'question':
                        valid = validateQuestion(element, answers);
                    break;
                    case 'contactDetails':
                        valid = validateContactDetails(element, answers);
                    break;
                    case 'invitation':
                        valid = validateInvitation(element, answers);
                    break;
                    case 'upload':
                    break;
                    case 'conditionalArea':
                        if (validateConditions(element.conditions, answers))
                            valid = validate(element.elements, answers);
                    break;
                }
            });
            
            return valid;
        }

        function validateQuestion(element, answers) {
            var answer = angular.copy(answers['q-'+element.questionId]),
                valid = true,
                message = '';
            
            if (element.required === true) {
                if ((typeof answer === 'undefined' || typeof answer.value === 'undefined') || answer.value.length === 0) {
                    valid = false;
                }
            }
            
            if (typeof answer !== 'undefined') {
                if (element.questionType === 'textfield') {                    
                    if (answer.type === 'numeric' && isFinite(parseFloat(answer.value)) === false) {
                        valid = false;
                        message = _locale('please enter a number for your answer').ucfirst();
                    } else if (answer.type === 'date') {
                        var date = answer.value.split('.');
                        
                        if (isNaN(new Date(date[2],parseInt(date[1])-1,date[0]))) {
                            message = _locale('please enter a valid date dd.mm.yyyy').ucfirst();
                        }
                    }
                }
                
                if (answer.extra && answer.extra.else 
                    && answer.extra.else.checked
                    && !answer.extra.else.answer.trim()) {
                    valid = false;
                    message = _locale('fill the custom answer').ucfirst();
                }
            }

            if (!valid) {
                element.error = true;
                element.errorMessage = message;
            } else {
                element.error = false;
                element.errorMessage = '';
            }

            return valid;
        }

        function validateContactDetails(element, answers) {
            var answer = angular.copy(answers['contactDetails']),
                valid = true,
                message = '';
            
            var isRegistration = (typeof element['isRegistration'] !== 'undefined' && element['isRegistration']) ? true : false;

            let age = false;
            
            if (answer.dateOfBirth && element.options.indexOf('guardianCheck') > -1) {
                const dobMoment = moment(answer.dateOfBirth, "DD.MM.YYYY");
                age = moment().diff(dobMoment, 'years');
            }

            angular.forEach(answer, function(value, key) {
                //Don't require the following fields.
                //Apple demands that phone is not a required field!
                if (['phone'].indexOf(key) !== -1) {
                    return true;
                }
                else if ((value !== null && typeof value !== 'undefined') && value.length === 0) {
                    //Only require guardian data if age is below 18
                    if (['guardianName', 'guardianSSN'].indexOf(key) === -1 || (age && age < 18)) {
                        valid = false;
                        message = _locale('we require you to fill all of these fields').ucfirst();
                    }
                } else if (key === 'email' && !validateEmail(value)) {
                    valid = false;
                    message = _locale('please provide a valid email address').ucfirst();
                } else if (['password','repeatPassword'].indexOf(key) >= 0 && answer['password'] !== answer['repeatPassword']) {
                    valid = false;
                    message = _locale('passwords given are not identical').ucfirst();
                } else if (isRegistration && key === 'consentGranted' && !value) {
                    valid = false;
                    message = _locale('you have to accept the terms of use').ucfirst();
                }
            });
                
            if (!valid) {
                element.error = true;                
                element.errorMessage = message;
            } else {
                element.error = false;
                element.errorMessage = '';
            }

            return valid;
        }

        function validateInvitation(element, answers) {
            var answer = angular.copy(answers['contactDetails']),
                valid = true,
                message = '';

            if (!valid) {
                element.error = true;
                element.errorMessage = message;
            } else {
                element.error = false;
                element.errorMessage = '';
            }

            return valid;
        }

        function injectAnswers(answers, inject) {
            angular.forEach(inject, function(values, questionId) {
                if (answers[questionId])
                    angular.forEach(values, function(value, key) {
                        answers[questionId][key] = value;
                    });
            });
        }

        this.baseUrl = '';

        this.saveSurveyAnswers = function(surveyId, data, callback) {
            http({
                method: 'POST',
                url: this.baseUrl+'/?action=pushsurveyanswers&surveyid='+surveyId+'&appauth='+settings.appAuthSecret,
                data: data
            }).success(callback);
        };

        this.getConsentCheckboxText = function(callback) {
            http({
                method: 'POST',
                url: this.baseUrl + '?getconsentcheckbox=1'
            }).success(callback);
        };

        this.validateCondition = validateCondition;
        this.validateConditions = validateConditions;
        this.createPages = createPages;
        this.removeHiddenAnswers = removeHiddenAnswers;
        this.validateEmail = validateEmail;
        this.validate = validate;
        this.injectAnswers = injectAnswers;
    }

    angular.module('wisenetwork.survey.service', ['wisenetwork.common'])
    .service('SurveyService', ['$http', SurveyService]);
})();
